// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.suppliertype-table-container {
  --table-bg-color: #fff;
  --table-border-color: var(--cui-border-color, #d8dbe0);
  --table-text-color: var(--cui-body-color, #4f5d73);
}
html[data-coreui-theme=dark] .suppliertype-table-container {
  --table-bg-color: var(--cui-dark-bg-subtle, #1e1e2f);
  --table-border-color: var(--cui-dark-border-subtle, #333);
  --table-text-color: var(--cui-body-color, #fff);
}
.suppliertype-table-container .table {
  border-color: var(--table-border-color) !important;
}
.suppliertype-table-container .table,
.suppliertype-table-container .table thead,
.suppliertype-table-container .table tbody,
.suppliertype-table-container .table tr,
.suppliertype-table-container .table th,
.suppliertype-table-container .table td {
  border-color: var(--table-border-color) !important;
}
.suppliertype-table-container .table:hover,
.suppliertype-table-container .table thead:hover,
.suppliertype-table-container .table tbody:hover,
.suppliertype-table-container .table tr:hover,
.suppliertype-table-container .table th:hover,
.suppliertype-table-container .table td:hover {
  border-color: var(--table-border-color) !important;
}
.suppliertype-table-container .card {
  border-color: var(--table-border-color) !important;
  background-color: var(--table-bg-color);
}
.suppliertype-table-container .card:hover {
  border-color: var(--table-border-color) !important;
}
.suppliertype-table-container .card .card-body {
  background-color: var(--table-bg-color);
  color: var(--table-text-color);
}
.suppliertype-table-container .table {
  width: 100%;
  margin-bottom: 0;
  color: var(--table-text-color);
}
.suppliertype-table-container .table .table-header-cell {
  border-color: var(--table-border-color) !important;
  font-weight: 600;
}
.suppliertype-table-container .table .table-header-cell.sortable-header {
  cursor: pointer;
}
.suppliertype-table-container .table .table-header-cell:hover {
  border-color: var(--table-border-color) !important;
}
.suppliertype-table-container .table tbody tr {
  border-color: var(--table-border-color) !important;
}
.suppliertype-table-container .table tbody tr:hover {
  border-color: var(--table-border-color) !important;
  background-color: inherit;
}
.suppliertype-table-container .table tbody tr td {
  border-color: var(--table-border-color) !important;
}
.suppliertype-table-container .table tbody tr td:hover {
  border-color: var(--table-border-color) !important;
}
.suppliertype-table-container .table-hover tbody tr:hover {
  background-color: inherit !important;
  border-color: var(--table-border-color) !important;
  color: var(--table-text-color) !important;
}
.suppliertype-table-container .table-hover tbody tr:hover td {
  color: var(--table-text-color) !important;
}
.suppliertype-table-container .table-hover tbody tr:hover th {
  color: var(--table-text-color) !important;
}
.suppliertype-table-container .pagination {
  margin-bottom: 0;
}
html[data-coreui-theme=dark] .suppliertype-table-container .pagination {
  --cui-pagination-bg: var(--table-bg-color);
  --cui-pagination-color: var(--table-text-color);
  --cui-pagination-active-bg: var(--cui-primary);
  --cui-pagination-active-color: var(--table-text-color);
  --cui-pagination-disabled-bg: var(--table-bg-color);
  --cui-pagination-disabled-color: var(--cui-secondary-color);
  --cui-pagination-border-color: var(--table-border-color);
}
html[data-coreui-theme=dark] .suppliertype-table-container .form-select {
  background-color: var(--table-bg-color);
  color: var(--table-text-color);
  border-color: var(--table-border-color);
}
html[data-coreui-theme=dark] .suppliertype-table-container .form-select:focus {
  background-color: var(--table-bg-color);
  color: var(--table-text-color);
}
html[data-coreui-theme=dark] .suppliertype-table-container .form-select option {
  background-color: var(--table-bg-color);
  color: var(--table-text-color);
}
.suppliertype-table-container .d-flex.justify-content-between.align-items-center.mt-3 {
  margin-top: 1rem;
}
.suppliertype-table-container .cursor-pointer {
  cursor: pointer;
  display: flex;
  justify-content: center;
}
.suppliertype-table-container .cursor-pointer:hover {
  opacity: 0.8;
}
.suppliertype-table-container .text-center {
  text-align: center;
  padding: 1.5rem;
  font-style: italic;
}
.suppliertype-table-container .badge-success {
  background-color: var(--cui-success) !important;
  color: #fff;
}
.suppliertype-table-container .badge-danger {
  background-color: var(--cui-danger) !important;
  color: #fff;
}
.suppliertype-table-container .table.table-hover > tbody > tr:hover {
  border-color: var(--table-border-color) !important;
  color: var(--table-text-color) !important;
}
.suppliertype-table-container .table.table-hover > tbody > tr:hover td {
  color: var(--table-text-color) !important;
}
.suppliertype-table-container .table.table-hover > tbody > tr:hover th {
  color: var(--table-text-color) !important;
}

.supplier-type-table-container {
  --table-bg-color: #fff;
  --table-border-color: var(--cui-border-color, #d8dbe0);
  --table-text-color: var(--cui-body-color, #4f5d73);
}
html[data-coreui-theme=dark] .supplier-type-table-container {
  --table-bg-color: var(--cui-dark-bg-subtle, #1e1e2f);
  --table-border-color: var(--cui-dark-border-subtle, #333);
  --table-text-color: var(--cui-body-color, #fff);
}
.supplier-type-table-container .table {
  border-color: var(--table-border-color) !important;
}
.supplier-type-table-container .table,
.supplier-type-table-container .table thead,
.supplier-type-table-container .table tbody,
.supplier-type-table-container .table tr,
.supplier-type-table-container .table th,
.supplier-type-table-container .table td {
  border-color: var(--table-border-color) !important;
}
.supplier-type-table-container .table:hover,
.supplier-type-table-container .table thead:hover,
.supplier-type-table-container .table tbody:hover,
.supplier-type-table-container .table tr:hover,
.supplier-type-table-container .table th:hover,
.supplier-type-table-container .table td:hover {
  border-color: var(--table-border-color) !important;
}
.supplier-type-table-container .card {
  border-color: var(--table-border-color) !important;
  background-color: var(--table-bg-color);
}
.supplier-type-table-container .card:hover {
  border-color: var(--table-border-color) !important;
}
.supplier-type-table-container .card .card-body {
  background-color: var(--table-bg-color);
  color: var(--table-text-color);
}
.supplier-type-table-container .table {
  width: 100%;
  margin-bottom: 0;
  color: var(--table-text-color);
}
.supplier-type-table-container .table .table-header-cell {
  border-color: var(--table-border-color) !important;
  font-weight: 600;
}
.supplier-type-table-container .table .table-header-cell.sortable-header {
  cursor: pointer;
}
.supplier-type-table-container .table .table-header-cell:hover {
  border-color: var(--table-border-color) !important;
}
.supplier-type-table-container .table tbody tr {
  border-color: var(--table-border-color) !important;
}
.supplier-type-table-container .table tbody tr:hover {
  border-color: var(--table-border-color) !important;
  background-color: inherit;
}
.supplier-type-table-container .table tbody tr td {
  border-color: var(--table-border-color) !important;
}
.supplier-type-table-container .table tbody tr td:hover {
  border-color: var(--table-border-color) !important;
}
.supplier-type-table-container .table-hover tbody tr:hover {
  background-color: inherit !important;
  border-color: var(--table-border-color) !important;
  color: var(--table-text-color) !important;
}
.supplier-type-table-container .table-hover tbody tr:hover td {
  color: var(--table-text-color) !important;
}
.supplier-type-table-container .table-hover tbody tr:hover th {
  color: var(--table-text-color) !important;
}
.supplier-type-table-container .pagination {
  margin-bottom: 0;
}
html[data-coreui-theme=dark] .supplier-type-table-container .pagination {
  --cui-pagination-bg: var(--table-bg-color);
  --cui-pagination-color: var(--table-text-color);
  --cui-pagination-active-bg: var(--cui-primary);
  --cui-pagination-active-color: var(--table-text-color);
  --cui-pagination-disabled-bg: var(--table-bg-color);
  --cui-pagination-disabled-color: var(--cui-secondary-color);
  --cui-pagination-border-color: var(--table-border-color);
}
html[data-coreui-theme=dark] .supplier-type-table-container .form-select {
  background-color: var(--table-bg-color);
  color: var(--table-text-color);
  border-color: var(--table-border-color);
}
html[data-coreui-theme=dark] .supplier-type-table-container .form-select:focus {
  background-color: var(--table-bg-color);
  color: var(--table-text-color);
}
html[data-coreui-theme=dark] .supplier-type-table-container .form-select option {
  background-color: var(--table-bg-color);
  color: var(--table-text-color);
}
.supplier-type-table-container .d-flex.justify-content-between.align-items-center.mt-3 {
  margin-top: 1rem;
}
.supplier-type-table-container .cursor-pointer {
  cursor: pointer;
  display: flex;
  justify-content: center;
}
.supplier-type-table-container .cursor-pointer:hover {
  opacity: 0.8;
}
.supplier-type-table-container .text-center {
  text-align: center;
  padding: 1.5rem;
  font-style: italic;
}
.supplier-type-table-container .badge-success {
  background-color: var(--cui-success) !important;
  color: #fff;
}
.supplier-type-table-container .badge-danger {
  background-color: var(--cui-danger) !important;
  color: #fff;
}
.supplier-type-table-container .table.table-hover > tbody > tr:hover {
  border-color: var(--table-border-color) !important;
  color: var(--table-text-color) !important;
}
.supplier-type-table-container .table.table-hover > tbody > tr:hover td {
  color: var(--table-text-color) !important;
}
.supplier-type-table-container .table.table-hover > tbody > tr:hover th {
  color: var(--table-text-color) !important;
}`, "",{"version":3,"sources":["webpack://./src/components/SupplierTypeTable/SupplierTypeTable.scss"],"names":[],"mappings":"AAAA;EACE,sBAAA;EACA,sDAAA;EACA,kDAAA;AACF;AACE;EACE,oDAAA;EACA,yDAAA;EACA,+CAAA;AACJ;AAEE;EACE,kDAAA;AAAJ;AAGE;;;;;;EAME,kDAAA;AADJ;AAGI;;;;;;EACE,kDAAA;AAIN;AAAE;EACE,kDAAA;EACA,uCAAA;AAEJ;AAAI;EACE,kDAAA;AAEN;AACI;EACE,uCAAA;EACA,8BAAA;AACN;AAGE;EACE,WAAA;EACA,gBAAA;EACA,8BAAA;AADJ;AAGI;EACE,kDAAA;EACA,gBAAA;AADN;AAGM;EACE,eAAA;AADR;AAIM;EACE,kDAAA;AAFR;AAMI;EACE,kDAAA;AAJN;AAMM;EACE,kDAAA;EACA,yBAAA;AAJR;AAOM;EACE,kDAAA;AALR;AAOQ;EACE,kDAAA;AALV;AAWE;EACE,oCAAA;EACA,kDAAA;EACA,yCAAA;AATJ;AAWI;EACE,yCAAA;AATN;AAYI;EACE,yCAAA;AAVN;AAcE;EACE,gBAAA;AAZJ;AAgBI;EACE,0CAAA;EACA,+CAAA;EACA,8CAAA;EACA,sDAAA;EACA,mDAAA;EACA,2DAAA;EACA,wDAAA;AAdN;AAiBI;EACE,uCAAA;EACA,8BAAA;EACA,uCAAA;AAfN;AAiBM;EACE,uCAAA;EACA,8BAAA;AAfR;AAkBM;EACE,uCAAA;EACA,8BAAA;AAhBR;AAqBE;EACE,gBAAA;AAnBJ;AAsBE;EACE,eAAA;EACA,aAAA;EACA,uBAAA;AApBJ;AAsBI;EACE,YAAA;AApBN;AAwBE;EACE,kBAAA;EACA,eAAA;EACA,kBAAA;AAtBJ;AAyBE;EACE,+CAAA;EACA,WAAA;AAvBJ;AA0BE;EACE,8CAAA;EACA,WAAA;AAxBJ;AA2BE;EACE,kDAAA;EACA,yCAAA;AAzBJ;AA2BI;EACE,yCAAA;AAzBN;AA4BI;EACE,yCAAA;AA1BN;;AA+BA;EACI,sBAAA;EACA,sDAAA;EACA,kDAAA;AA5BJ;AA8BI;EACE,oDAAA;EACA,yDAAA;EACA,+CAAA;AA5BN;AA+BI;EACE,kDAAA;AA7BN;AAgCI;;;;;;EAME,kDAAA;AA9BN;AAgCM;;;;;;EACE,kDAAA;AAzBR;AA6BI;EACE,kDAAA;EACA,uCAAA;AA3BN;AA6BM;EACE,kDAAA;AA3BR;AA8BM;EACE,uCAAA;EACA,8BAAA;AA5BR;AAgCI;EACE,WAAA;EACA,gBAAA;EACA,8BAAA;AA9BN;AAgCM;EACE,kDAAA;EACA,gBAAA;AA9BR;AAgCQ;EACE,eAAA;AA9BV;AAiCQ;EACE,kDAAA;AA/BV;AAmCM;EACE,kDAAA;AAjCR;AAmCQ;EACE,kDAAA;EACA,yBAAA;AAjCV;AAoCQ;EACE,kDAAA;AAlCV;AAoCU;EACE,kDAAA;AAlCZ;AAwCI;EACE,oCAAA;EACA,kDAAA;EACA,yCAAA;AAtCN;AAwCM;EACE,yCAAA;AAtCR;AAyCM;EACE,yCAAA;AAvCR;AA2CI;EACE,gBAAA;AAzCN;AA6CM;EACE,0CAAA;EACA,+CAAA;EACA,8CAAA;EACA,sDAAA;EACA,mDAAA;EACA,2DAAA;EACA,wDAAA;AA3CR;AA8CM;EACE,uCAAA;EACA,8BAAA;EACA,uCAAA;AA5CR;AA8CQ;EACE,uCAAA;EACA,8BAAA;AA5CV;AA+CQ;EACE,uCAAA;EACA,8BAAA;AA7CV;AAkDI;EACE,gBAAA;AAhDN;AAmDI;EACE,eAAA;EACA,aAAA;EACA,uBAAA;AAjDN;AAmDM;EACE,YAAA;AAjDR;AAqDI;EACE,kBAAA;EACA,eAAA;EACA,kBAAA;AAnDN;AAsDI;EACE,+CAAA;EACA,WAAA;AApDN;AAuDI;EACE,8CAAA;EACA,WAAA;AArDN;AAwDI;EACE,kDAAA;EACA,yCAAA;AAtDN;AAwDM;EACE,yCAAA;AAtDR;AAyDM;EACE,yCAAA;AAvDR","sourcesContent":[".suppliertype-table-container {\n  --table-bg-color: #fff;\n  --table-border-color: var(--cui-border-color, #d8dbe0);\n  --table-text-color: var(--cui-body-color, #4f5d73);\n\n  html[data-coreui-theme=\"dark\"] & {\n    --table-bg-color: var(--cui-dark-bg-subtle, #1e1e2f);\n    --table-border-color: var(--cui-dark-border-subtle, #333);\n    --table-text-color: var(--cui-body-color, #fff);\n  }\n\n  .table {\n    border-color: var(--table-border-color) !important;\n  }\n\n  .table,\n  .table thead,\n  .table tbody,\n  .table tr,\n  .table th,\n  .table td {\n    border-color: var(--table-border-color) !important;\n    \n    &:hover {\n      border-color: var(--table-border-color) !important;\n    }\n  }\n\n  .card {\n    border-color: var(--table-border-color) !important;\n    background-color: var(--table-bg-color);\n    \n    &:hover {\n      border-color: var(--table-border-color) !important;\n    }\n    \n    .card-body {\n      background-color: var(--table-bg-color);\n      color: var(--table-text-color);\n    }\n  }\n\n  .table {\n    width: 100%;\n    margin-bottom: 0;\n    color: var(--table-text-color);\n    \n    .table-header-cell {\n      border-color: var(--table-border-color) !important;\n      font-weight: 600;\n      \n      &.sortable-header {\n        cursor: pointer;\n      }\n      \n      &:hover {\n        border-color: var(--table-border-color) !important;\n      }\n    }\n    \n    tbody tr {\n      border-color: var(--table-border-color) !important;\n      \n      &:hover {\n        border-color: var(--table-border-color) !important;\n        background-color: inherit;\n      }\n      \n      td {\n        border-color: var(--table-border-color) !important;\n        \n        &:hover {\n          border-color: var(--table-border-color) !important;\n        }\n      }\n    }\n  }\n\n  .table-hover tbody tr:hover {\n    background-color: inherit !important;\n    border-color: var(--table-border-color) !important;\n    color: var(--table-text-color) !important;\n    \n    td {\n      color: var(--table-text-color) !important;\n    }\n    \n    th {\n      color: var(--table-text-color) !important;\n    }\n  }\n\n  .pagination {\n    margin-bottom: 0;\n  }\n\n  html[data-coreui-theme=\"dark\"] & {\n    .pagination {\n      --cui-pagination-bg: var(--table-bg-color);\n      --cui-pagination-color: var(--table-text-color);\n      --cui-pagination-active-bg: var(--cui-primary);\n      --cui-pagination-active-color: var(--table-text-color);\n      --cui-pagination-disabled-bg: var(--table-bg-color);\n      --cui-pagination-disabled-color: var(--cui-secondary-color);\n      --cui-pagination-border-color: var(--table-border-color);\n    }\n    \n    .form-select {\n      background-color: var(--table-bg-color);\n      color: var(--table-text-color);\n      border-color: var(--table-border-color);\n      \n      &:focus {\n        background-color: var(--table-bg-color);\n        color: var(--table-text-color);\n      }\n      \n      option {\n        background-color: var(--table-bg-color);\n        color: var(--table-text-color);\n      }\n    }\n  }\n\n  .d-flex.justify-content-between.align-items-center.mt-3 {\n    margin-top: 1rem;\n  }\n\n  .cursor-pointer {\n    cursor: pointer;\n    display: flex;\n    justify-content: center;\n    \n    &:hover {\n      opacity: 0.8;\n    }\n  }\n\n  .text-center {\n    text-align: center;\n    padding: 1.5rem;\n    font-style: italic;\n  }\n\n  .badge-success {\n    background-color: var(--cui-success) !important;\n    color: #fff;\n  }\n\n  .badge-danger {\n    background-color: var(--cui-danger) !important;\n    color: #fff;\n  }\n\n  .table.table-hover > tbody > tr:hover {\n    border-color: var(--table-border-color) !important;\n    color: var(--table-text-color) !important;\n    \n    td {\n      color: var(--table-text-color) !important;\n    }\n    \n    th {\n      color: var(--table-text-color) !important;\n    }\n  }\n}\n\n.supplier-type-table-container {\n    --table-bg-color: #fff;\n    --table-border-color: var(--cui-border-color, #d8dbe0);\n    --table-text-color: var(--cui-body-color, #4f5d73);\n  \n    html[data-coreui-theme=\"dark\"] & {\n      --table-bg-color: var(--cui-dark-bg-subtle, #1e1e2f);\n      --table-border-color: var(--cui-dark-border-subtle, #333);\n      --table-text-color: var(--cui-body-color, #fff);\n    }\n  \n    .table {\n      border-color: var(--table-border-color) !important;\n    }\n  \n    .table,\n    .table thead,\n    .table tbody,\n    .table tr,\n    .table th,\n    .table td {\n      border-color: var(--table-border-color) !important;\n      \n      &:hover {\n        border-color: var(--table-border-color) !important;\n      }\n    }\n  \n    .card {\n      border-color: var(--table-border-color) !important;\n      background-color: var(--table-bg-color);\n      \n      &:hover {\n        border-color: var(--table-border-color) !important;\n      }\n      \n      .card-body {\n        background-color: var(--table-bg-color);\n        color: var(--table-text-color);\n      }\n    }\n  \n    .table {\n      width: 100%;\n      margin-bottom: 0;\n      color: var(--table-text-color);\n      \n      .table-header-cell {\n        border-color: var(--table-border-color) !important;\n        font-weight: 600;\n        \n        &.sortable-header {\n          cursor: pointer;\n        }\n        \n        &:hover {\n          border-color: var(--table-border-color) !important;\n        }\n      }\n      \n      tbody tr {\n        border-color: var(--table-border-color) !important;\n        \n        &:hover {\n          border-color: var(--table-border-color) !important;\n          background-color: inherit;\n        }\n        \n        td {\n          border-color: var(--table-border-color) !important;\n          \n          &:hover {\n            border-color: var(--table-border-color) !important;\n          }\n        }\n      }\n    }\n  \n    .table-hover tbody tr:hover {\n      background-color: inherit !important;\n      border-color: var(--table-border-color) !important;\n      color: var(--table-text-color) !important;\n      \n      td {\n        color: var(--table-text-color) !important;\n      }\n      \n      th {\n        color: var(--table-text-color) !important;\n      }\n    }\n  \n    .pagination {\n      margin-bottom: 0;\n    }\n  \n    html[data-coreui-theme=\"dark\"] & {\n      .pagination {\n        --cui-pagination-bg: var(--table-bg-color);\n        --cui-pagination-color: var(--table-text-color);\n        --cui-pagination-active-bg: var(--cui-primary);\n        --cui-pagination-active-color: var(--table-text-color);\n        --cui-pagination-disabled-bg: var(--table-bg-color);\n        --cui-pagination-disabled-color: var(--cui-secondary-color);\n        --cui-pagination-border-color: var(--table-border-color);\n      }\n      \n      .form-select {\n        background-color: var(--table-bg-color);\n        color: var(--table-text-color);\n        border-color: var(--table-border-color);\n        \n        &:focus {\n          background-color: var(--table-bg-color);\n          color: var(--table-text-color);\n        }\n        \n        option {\n          background-color: var(--table-bg-color);\n          color: var(--table-text-color);\n        }\n      }\n    }\n  \n    .d-flex.justify-content-between.align-items-center.mt-3 {\n      margin-top: 1rem;\n    }\n  \n    .cursor-pointer {\n      cursor: pointer;\n      display: flex;\n      justify-content: center;\n      \n      &:hover {\n        opacity: 0.8;\n      }\n    }\n  \n    .text-center {\n      text-align: center;\n      padding: 1.5rem;\n      font-style: italic;\n    }\n  \n    .badge-success {\n      background-color: var(--cui-success) !important;\n      color: #fff;\n    }\n  \n    .badge-danger {\n      background-color: var(--cui-danger) !important;\n      color: #fff;\n    }\n  \n    .table.table-hover > tbody > tr:hover {\n      border-color: var(--table-border-color) !important;\n      color: var(--table-text-color) !important;\n      \n      td {\n        color: var(--table-text-color) !important;\n      }\n      \n      th {\n        color: var(--table-text-color) !important;\n      }\n    }\n  }\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
